import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { RegionService } from '../../../core/api/region.service';
import { RoleEnum } from '../../../shared/constants/role.enums';
import { Cohort, Region } from '../../../shared/models';
import * as fromApp from '../../../store/index';

@Component({
  selector: 'fc-manage-regions-page',
  templateUrl: './manage-regions-page.component.html',
  styleUrls: ['./manage-regions-page.component.scss'],
})
export class ManageRegionsPageComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  displayedColumns: string[] = ['name', 'refreshDate'];

  dataSource: MatTableDataSource<Region>;

  isSuperAdmin = false;

  constructor(
    readonly router: Router, readonly store: Store<fromApp.AppState>, readonly regionService: RegionService) {}

  ngOnInit() {
    this.store
      .select('auth', 'currentUser')
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(currentUser => {
        this.isSuperAdmin = currentUser.hasRole(RoleEnum.SuperAdmin);
      });
    this.regionService.getAllRegions().subscribe(regions => {
      this.dataSource = new MatTableDataSource(regions);
    });
  }

  clickRow(event: MouseEvent, row: Cohort): void {
    this.router.navigate(['/admin/manage-region', row.id]);
  }
}
